import { FONTS } from '@app/src/ui';
import styled from 'styled-components';

export const Wrapper = styled.a`
  background: #FFD24D;
  padding: 13px 45px 13px 15px;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Title = styled.p`
  margin-right: 20px;
  font-size: 12px;
  font-family: ${FONTS.ROBOTO};
`;

export const Message = styled.p`
  font-size: 14px;
  font-family: ${FONTS.ROBOTO_BOLD};
`;

export const IconWrapper = styled.span`
  position: absolute;
  right: 15px;
  cursor: pointer;
  z-index: 100;
  display: inline-block;
  width: 20px;
  height: 20px;
`;